import {Observable} from 'rxjs';

import {combineEpics} from 'web-app/util/redux-observable';
import * as ProductActions from 'web-app/react/entities/products/actions';
import * as SessionActions from 'web-app/react/entities/sessions/actions';
import BehaviorsCollection from 'web-app/behaviors/behaviors-collection';

import * as Api from './api';
import * as Actions from './actions';

export const fetchPlansByChildIdsObservable = childIds => {
    return Api.fetchPlansByChildIds(childIds).flatMap(response => [
        Actions.fetchPlansByChildIdsSuccess.action({plans: response.plans}),
        ProductActions.fetchAllSuccess.action(response.products, new BehaviorsCollection()),
        SessionActions.fetchAllSuccess.action(response.sessions, new BehaviorsCollection()),
    ]);
};

const fetchPlansByChildIds = action$ =>
    action$
        .ofType(Actions.fetchPlansByChildIds.type)
        .mergeMap(({payload}) =>
            fetchPlansByChildIdsObservable(payload.childIds).catch(e =>
                Observable.of(Actions.fetchPlansByChildIdsFailed.action(e)),
            ),
        );

export default combineEpics(fetchPlansByChildIds);
